import React from 'react';

import Layout from '../components/blocks/Layout';
import SEO from '../components/blocks/SEO';
import AboveTheFoldSection from '../components/slides/get-started/AboveTheFoldSection';
import BeforeVsAfter from '../components/slides/home/BeforeVsAfter';
import TrustedBy from '../components/slides/home/TrustedBy';
import WhatYouCanBuild from '../components/slides/home/WhatYouCanBuild';
import CourseCreator from '../components/slides/home/CourseCreator';
import Features from '../components/slides/home/Features';
import HelpfulTools from '../components/slides/home/HelpfulTools';
import BlogPosts from '../components/slides/home/BlogPosts';
import FeaturedIn from '../components/slides/get-started/FeaturedIn';
import FeaturedServices from '../components/slides/get-started/FeaturedServices';

const HomePage = () => (
  <Layout>
    <SEO title="Authentic Evergreen Marketing | Deadline Funnel" />
    <AboveTheFoldSection />
    <FeaturedIn />
    <FeaturedServices />
    <BeforeVsAfter />
    <TrustedBy />
    <WhatYouCanBuild />
    <CourseCreator />
    <Features />
    <HelpfulTools />
    <BlogPosts />
  </Layout>
);

export default HomePage;
